const pagesWithSecondaryNavStyle = ["/inspector"];

export const shouldUseSecondaryNavStyle = (pathname: string): boolean => {
  return pagesWithSecondaryNavStyle.includes(pathname);
};
